import { Button } from "react-bootstrap";
import { useCallback } from "react";
import { useUIConfig } from "../Context";
import Icon from "../../../../controls/Icon";

const RenderParams = ({ params, disabled, currentPath, updateCallback, resetCallback, removeCallback }) => {
    const { showAdvancedProps, renderComponentForParameter } = useUIConfig();

    const renderButton = useCallback((param) => {
        if (param.allowRemove) {
            return <div className="col-fixed-2 mt-auto p-0">
                <Button
                    variant='outline-danger'
                    className='btn-lg ms-1 border-0 p-0 pb-1'
                    onClick={() => removeCallback(currentPath, param.name)}
                >
                    <Icon icon='Delete' />
                </Button>
            </div >
        }

        if (param.overridesValue !== undefined && !['Object', 'CSS', 'LayoutItem', 'LayoutItemList', 'SortableObject', 'CustomKeyObject'].includes(param.type)) {
            return <div className="col-fixed-2 mt-auto p-0">
                <Button
                    variant='outline'
                    className='btn-lg ms-1 border-0 p-0 pb-1'
                    onClick={() => { resetCallback(param.name); }}
                >
                    <Icon icon='FastRewind' />
                </Button>
            </div>
        }

        // If it is CSS we let it take the whole space since it is in its own tab
        if (!['CSS'].includes(param.type)) {
            return <div className="col-fixed-2 mt-auto p-0">
            </div>
        }

        return;
    }, [currentPath, removeCallback, resetCallback]);

    const renderParam = useCallback((param, index) => {
        return <div className="row" key={index}>
            <div className="col mt-2">
                {renderComponentForParameter({ param, index, disabled, currentPath, configKey: param.configKey, updateCallback, resetCallback })}
            </div>
            {renderButton(param)}
        </div>
    }, [currentPath, disabled, updateCallback, resetCallback, renderComponentForParameter, renderButton]);

    return <>
        {params.filter(param => !param.advancedProp).map((param, index) => renderParam(param, index))}
        {showAdvancedProps && params.filter(param => param.advancedProp).map((param, index) => renderParam(param, index))}
    </>
}

export default RenderParams;